// import { sortArray } from "../../../helpers/utils/sortArray";
// import { rub } from "../../../helpers/converters";

export default {
  SET_REBID_ID: (state, data) => {
    state.rebid_info.orderId = data;
  },
};
